import React from "react";
import PropTypes from "prop-types";
import TabNavigationItem from "./TabNavigationItem";

const TabNavigation = ({ tabsNavArray, activeTab, onHandleTabClick }) => {
  // Build list of navigation items
  const tabsNav = tabsNavArray.map((navItem, index) => {
    return (
      <TabNavigationItem
        key={navItem.name + "_" + navItem.layer_id}
        id={index}
        navItem={navItem.name}
        active={index === activeTab}
        onHandleTabClick={onHandleTabClick}
      />
    );
  });

  return <div className="tabs__navigation">{tabsNav}</div>;
};

export default TabNavigation;

TabNavigation.propTypes = {
  tabsNavArray: PropTypes.array.isRequired,
};
